export { default as baseColorScheme } from './color-scheme'
